import React, { FunctionComponent as FC } from 'react';
import './index.scss';

import Register from './RegisterForm';

interface RegisterPageProps {

}

const RegisterPage: FC<RegisterPageProps> = (props) => {

  const {
  } = props

  return (
    <div className='register-page-div'>
      <Register />
    </div>

  )
}

export default RegisterPage